<template>
  <hit_login>
    <hit_dashboard>
      <div class="hit-container">
        <importData v-if="data" :data="data" />
        <loginForm v-else :callback="function(data){ setData(data); }"/>
      </div>
    </hit_dashboard>
  </hit_login>
</template>

<script>

import loginForm from '@core/components/hitorshit/login'
import importData from '@core/components/hitorshit/import'

export default{

  components: {loginForm, importData},

  data () {
    return {
      data: false
    }
  },

  methods: {
    setData (data) {
      // sessionStorage.setItem("hitorshit", JSON.stringify(data));
      this.data = data
    }
  },

  mounted () {

    // if( sessionStorage.getItem("hitorshit") )
    // this.data = JSON.parse(sessionStorage.getItem("hitorshit"));
  }
}
</script>
